<template>
  <search-wrapper :model="searchParams" @search="search">
    <label-input
      class="control"
      labelWidth="100px"
      label="通用名"
      placeholder="请输入通用名"
      width="330px"
      v-model="drugName"
      prop="drugName"
      :input-attr="{ maxlength: 50 }"
      type="input"
      clearable
    />
    <label-input
      class="control"
      labelWidth="100px"
      label="生产厂家"
      placeholder="请输入生产厂家"
      width="330px"
      prop="drugManufacturer"
      v-model="drugManufacturer"
      :input-attr="{ maxlength: 50 }"
      type="input"
      clearable
    />

    <label-input
      class="control"
      labelWidth="100px"
      label="生产批号"
      placeholder="请输入生产批号"
      prop="drugProductBatchNo"
      width="330px"
      v-model="drugProductBatchNo"
      :input-attr="{ maxlength: 50 }"
      type="input"
      clearable
    />

    <label-input class="control" label="分类" width="230px" prop="drugVariety">
      <el-select v-model="drugVariety" placeholder="请选择分类">
        <el-option
          v-for="item in drugVarietyOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </label-input>
    <label-input
      class="control"
      prop="purchaseId"
      labelWidth="100px"
      label="入库单号"
      placeholder="请输入入库单号"
      width="330px"
      v-model="purchaseId"
      :input-attr="{ maxlength: 50 }"
      type="input"
      clearable
    />
    <label-input class="control" label="入库时间" width="435px" prop="dateRange">
      <el-date-picker
        v-model="dateRange"
        type="daterange"
        :picker-options="pickerOptions"
        range-separator="-"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :defaultTime="['00:00:00', '23:59:59']"
        valueFormat="yyyy-MM-dd HH:mm:ss"
        align="right"
      ></el-date-picker>
    </label-input>
    <label-input class="control" label="有效期至" width="435px" prop="validityPeriod">
      <el-date-picker
        v-model="validityPeriod"
        type="daterange"
        range-separator="-"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :defaultTime="['00:00:00', '23:59:59']"
        valueFormat="yyyy-MM-dd HH:mm:ss"
        align="right"
      ></el-date-picker>
    </label-input>
    <label-input
      class="control"
      labelWidth="100px"
      label="供应商"
      placeholder="请输入供应商"
      width="330px"
      v-model="supplierName"
      prop="supplierName"
      :input-attr="{ maxlength: 50 }"
      type="input"
      clearable
    />
    <label-input class="control" label="是否上传" width="230px" prop="certUploadStatus">
      <el-select v-model="certUploadStatus" placeholder="">
        <el-option
          v-for="item in certUploadStatusOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </label-input>
    <label-input class="control" label="是否处方药" width="230px" prop="isPrescription">
      <el-select v-model="isPrescription" placeholder="">
        <el-option
          v-for="item in isPrescriptionOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </label-input>

    <!-- <el-button class="search-btn" @click="search">查询</el-button> -->
  </search-wrapper>
</template>

<script>
import dayjs from 'dayjs';
import Fetch from '@/api';
import labelInput from '@/components/global/form/labelInputForSupervision';
import searchWrapper from '@/components/global/form/searchWrapper';

export default {
  name: 'searchBar',
  props: {
    type: {
      type: String
    },
    searchParams: {
      type: Object,
      default: () => ({})
    },
    storeId: {
      type: Number || undefined
    }
  },
  components: {
    labelInput,
    searchWrapper
  },
  computed: {
    drugName: {
      get() {
        return this.searchParams.drugName;
      },
      set(val) {
        this.$emit('changeSearchParams', {
          key: 'drugName',
          value: val
        });
      }
    },
    isPrescription: {
      get() {
        return this.searchParams.isPrescription;
      },
      set(val) {
        this.$emit('changeSearchParams', {
          key: 'isPrescription',
          value: val
        });
      }
    },
    drugManufacturer: {
      get() {
        return this.searchParams.drugManufacturer;
      },
      set(val) {
        this.$emit('changeSearchParams', {
          key: 'drugManufacturer',
          value: val
        });
      }
    },
    drugProductBatchNo: {
      get() {
        return this.searchParams.drugProductBatchNo;
      },
      set(val) {
        this.$emit('changeSearchParams', {
          key: 'drugProductBatchNo',
          value: val
        });
      }
    },
    purchaseId: {
      get() {
        return this.searchParams.purchaseId;
      },
      set(val) {
        this.$emit('changeSearchParams', {
          key: 'purchaseId',
          value: val
        });
      }
    },
    drugVariety: {
      get() {
        return this.searchParams.drugVariety;
      },
      set(val) {
        this.$emit('changeSearchParams', {
          key: 'drugVariety',
          value: val
        });
      }
    },
    supplierName: {
      get() {
        return this.searchParams.supplierName;
      },
      set(val) {
        this.$emit('changeSearchParams', {
          key: 'supplierName',
          value: val
        });
      }
    },
    validityPeriod: {
      get() {
        return this.searchParams.validityPeriod;
      },
      set(val) {
        this.$emit('changeSearchParams', {
          key: 'validityPeriod',
          value: val
        });
      }
    },
    certUploadStatus: {
      get() {
        return this.searchParams.certUploadStatus;
      },
      set(val) {
        this.$emit('changeSearchParams', {
          key: 'certUploadStatus',
          value: val
        });
      }
    },
    dateRange: {
      get() {
        return this.searchParams.dateRange;
      },
      set(val) {
        this.$emit('changeSearchParams', {
          key: 'dateRange',
          value: val
        });
      }
    }, // certUploadStatus
    certUploadStatusOptions() {
      return [
        { label: '全部', value: null },
        { label: '已上传', value: 1 },
        { label: '未上传', value: 0 }
      ];
    },
    drugVarietyOptions() {
      return [
        { label: '全部', value: null },
        { label: '一般药品', value: 'YBYP' },
        { label: '食品保健品', value: 'BJSP' },
        { label: '中药饮片', value: 'ZYYP' },
        { label: '中药材', value: 'ZYC' },
        { label: '医疗器械', value: 'YLQX' },
        { label: '医用耗材', value: 'YYHC' },
        { label: '其他', value: 'QT' }
      ];
    },
    isPrescriptionOptions() {
      return [
        { label: '全部', value: null },
        { label: '处方药', value: 1 },
        { label: '非处方药', value: 0 }
      ];
    },
    pickerOptions1() {
      return {
        disabledDate(date) {
          return date.getTime() < new Date().getTime();
        }
      };
    },
    pickerOptions() {
      return {
        shortcuts: [
          {
            text: '昨日',
            onClick(picker) {
              const yesterday = dayjs().subtract(1, 'days');
              picker.$emit('pick', [
                yesterday.startOf('day').format('YYYY-MM-DD HH:mm:ss'),
                yesterday.endOf('day').format('YYYY-MM-DD HH:mm:ss')
              ]);
            }
          },
          {
            text: '本周',
            onClick(picker) {
              picker.$emit('pick', [
                dayjs().startOf('isoWeek').format('YYYY-MM-DD HH:mm:ss'),
                dayjs().endOf('isoWeek').format('YYYY-MM-DD HH:mm:ss')
              ]);
            }
          },
          {
            text: '本月',
            onClick(picker) {
              picker.$emit('pick', [
                dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
                dayjs().endOf('month').format('YYYY-MM-DD HH:mm:ss')
              ]);
            }
          },
          {
            text: '本年',
            onClick(picker) {
              picker.$emit('pick', [
                dayjs().startOf('year').format('YYYY-MM-DD HH:mm:ss'),
                dayjs().endOf('year').format('YYYY-MM-DD HH:mm:ss')
              ]);
            }
          }
        ]
      };
    }
  },
  methods: {
    search() {
      this.$emit('search');
    }
    // queryOrderId(queryString, cb) {
    //   const { storeId, type } = this;
    //   const api = type === 'fourClass' ? Fetch.getSupervisionOrderList : Fetch.getSupervisionSpecialOrderList;
    //   api({ orderId: queryString, storeId, pageNo: 1, pageSize: 30 }).then(({ data }) => {
    //     cb(data);
    //   });
    // }
  }
};
</script>

<style lang="scss" scoped>
.search-bar-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 10px;

  // .control {
  //   margin-right: 16px;
  //   margin-bottom: 10px;
  // }

  .zy-date-picker {
    margin-right: 16px;
    margin-bottom: 10px;
  }

  .search-btn {
    margin-bottom: 10px;
    height: 40px !important;
    width: 80px !important;
    color: #1e8dff !important;
    background: #ffffff !important;
    border: 1px solid #1e8dff !important;
    &:hover {
      background: rgba(68, 184, 91, 0.1) !important;
    }
  }

  /deep/.date-picker {
    border: unset;
    padding-right: 0;
  }
}
</style>
